__turbopack_context__.v({
  "tooltip-content": "tooltip-module-scss-module__TGSEBG__tooltip-content",
  "trigger": "tooltip-module-scss-module__TGSEBG__trigger",
  "trigger-visible": "tooltip-module-scss-module__TGSEBG__trigger-visible",
});
